(ns ncr.widgets.input
  (:require
   [ncr.etc.pf :as pf]
   [uix.core.alpha :as uix]
   [ncr.widgets.pf :as wpf]))

(defn c-autocomplete [{:keys [inline? on-commit on-cancel add-on suggestions ref] :as props}]
  (let
    [ref' (uix/ref)

     props'
     (merge
       {:Component "input"
        :offsetY 18
        :trigger ["" " "]
        :spacer ""
        :minChars 1}
       (dissoc props :inline? :on-commit :on-cancel :add-on :suggestions :ref)
       {:class :pf-c-form-control
        :ref ref'})

     c-autocomplete [pf/c-autocomplete-input props']

     suggestions'
     (when (seq suggestions)
       [pf/c-chip-group {:class :ncr-recent}
        (for [[text on-click] suggestions]
          ^{:key text} [wpf/c-chip text on-click])])]

    (uix/with-effect [ref @ref']
      (fn []
        (when-let [el (and ref (some-> ^js @ref' .-refInput .-current))]
          (reset! ref el))))

    (if inline?
      [:div {:class :ncr-c-inline-edit}
       [:div {:class [:pf-c-input-group :ncr-c-inline-edit__input]}
        c-autocomplete

        (when add-on [pf/c-input-group-text {:variant :plain} add-on])

        [:div {:class [:pf-m-action-group :pf-m-icon-group]}
         [pf/c-button
          {:variant :plain
           :class [:pf-m-valid :pf-u-active-color-100]
           :on-click on-commit}
          [pf/c-check-icon]]
         [pf/c-button
          {:variant :plain
           :on-click on-cancel}
          [pf/c-times-icon]]]]
       (when suggestions' suggestions')]
      [:<>
       c-autocomplete
       (when suggestions' suggestions')])))
